import { useEffect, useMemo, useState } from 'react';
import {
  getStandaloneChargePublic,
  StandaloneChargePublicDTO,
  StandaloneChargeStatusEnum
} from '../../../services/standalone-charges';

export const useStandaloneChargePayment = (token?: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [charge, setCharge] = useState<StandaloneChargePublicDTO | null>(null);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      setError('Link de cobrança inválido.');
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    getStandaloneChargePublic(token)
      .then(data => {
        if (!cancelled) {
          setCharge(data);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err?.message || 'Não foi possível carregar os dados da cobrança.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  const isFinished = useMemo(() => {
    return (
      charge?.status === StandaloneChargeStatusEnum.paid ||
      charge?.status === StandaloneChargeStatusEnum.expired ||
      charge?.status === StandaloneChargeStatusEnum.cancelled
    );
  }, [charge?.status]);

  return {
    loading,
    error,
    charge,
    isFinished
  };
};
